import { render, staticRenderFns } from "./VisualizarMonitoramentoSocioambiental.vue?vue&type=template&id=171651c0&scoped=true&lang=pug"
import script from "./VisualizarMonitoramentoSocioambiental.vue?vue&type=script&lang=js"
export * from "./VisualizarMonitoramentoSocioambiental.vue?vue&type=script&lang=js"
import style0 from "./VisualizarMonitoramentoSocioambiental.vue?vue&type=style&index=0&id=171651c0&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "171651c0",
  null
  
)

export default component.exports